/* eslint-disable no-console */
// import * as testData from './test-data';
import { updateAccountIconStatus, updateAccountStatusMessage } from './account-status-helpers';

const baseUrl = '';
// Local Web API controller that replaces the external digital user REST service.
const apiBaseUrl = '/api/digitaluser';

// Small plain-JavaScript XHR helper used for every call to the ApiController.
const ajax = ({
  method,
  url,
  contentType = 'application/json',
  accept,
  body = null,
  parse = true,
  onSuccess,
  onError,
}) => {
  const request = new XMLHttpRequest();
  request.open(method, url, true);
  if (contentType) {
    request.setRequestHeader('Content-type', contentType);
  }
  if (accept) {
    request.setRequestHeader('Accept', accept);
  }
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      if (onSuccess) {
        onSuccess(parse ? JSON.parse(request.responseText) : request.responseText);
      }
    } else if (onError) {
      onError(request);
    }
  };
  request.onerror = () => {
    if (onError) {
      onError(request);
    }
  };
  request.send(body);
};

const addVisualization = (data, callback) => {
  // The logged-in user id is resolved from the server-side session in the ApiController.
  ajax({
    method: 'POST',
    url: `${apiBaseUrl}/visualization`,
    contentType: 'text/plain',
    accept: 'application/json',
    body: data.toString(),
    parse: false,
    onSuccess: () => {
      if (callback) {
        callback();
      }
      updateAccountIconStatus();
      updateAccountStatusMessage('visualizer scene', 'add');
    },
    onError: () => {
      console.log('error');
    },
  });
};

const addPhoto = (data, callback) => {
  const {
    imageUrl,
    thumbUrl,
    description,
  } = data;
  ajax({
    method: 'POST',
    url: `${apiBaseUrl}/photo`,
    body: JSON.stringify({
      'photo-url': imageUrl,
      'thumbnail-url': thumbUrl,
      description,
    }),
    onSuccess: (responseData) => {
      if (callback) {
        callback(responseData);
      }
      updateAccountIconStatus();
      updateAccountStatusMessage('photo', 'add');
    },
    onError: () => {
      console.log('error');
    },
  });
};

const addDealer = (data, callback) => {
  ajax({
    method: 'POST',
    url: `${apiBaseUrl}/dealer`,
    body: JSON.stringify({
      'record-id': data['record-id'],
      'ship-to-account': data['ship-to-account'],
    }),
    onSuccess: (responseData) => {
      if (callback) {
        callback(responseData);
      }
      updateAccountIconStatus();
      updateAccountStatusMessage('dealer', 'add');
    },
    onError: () => {
      console.log('error');
    },
  });
};

const addSwatch = (data, callback) => {
  const {
    productLineCode,
    colorNumber,
    swatchId,
  } = data;
  ajax({
    method: 'POST',
    url: `${apiBaseUrl}/swatch`,
    body: JSON.stringify({
      'product-line-code': productLineCode,
      'color-number': colorNumber,
      'swatch-id': swatchId,
    }),
    onSuccess: (responseData) => {
      if (callback) {
        callback(responseData);
      }
      updateAccountIconStatus();
      updateAccountStatusMessage('swatch', 'add');
    },
    onError: () => {
      console.log('error');
    },
  });
};

const addSwatches = (data, callbacks) => {
  const swatchlist = data.map(swatch => ({
    'user-id': window.userId,
    'product-line-code': swatch.productLineCode,
    'color-number': swatch.colorNumber,
    'swatch-id': swatch.swatchId,
    'widen-url': swatch.widenUrl,
  }));
  ajax({
    method: 'POST',
    url: `${baseUrl}/addswatches`,
    body: JSON.stringify({
      data: JSON.stringify({
        swatchlist,
      }),
    }),
    onSuccess: (responseData) => {
      if (callbacks && callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    },
    onError: (request) => {
      if (callbacks && callbacks.onError) {
        callbacks.onError(JSON.parse(request.responseText));
      }
    },
  });
};

const removeItemByType = (type, id, callback) => {
  let requestUrl;
  let msgType = '';
  switch (type) {
    case 'location':
      requestUrl = `${apiBaseUrl}/dealer`;
      msgType = 'dealer';
      break;
    case 'photo':
      requestUrl = `${apiBaseUrl}/photo`;
      msgType = 'photo';
      break;
    case 'visualization':
      requestUrl = `${apiBaseUrl}/visualization`;
      msgType = 'visualizer scene';
      break;
    case 'swatch':
      requestUrl = `${apiBaseUrl}/swatch`;
      msgType = 'swatch';
      break;
    default:
      break;
  }
  ajax({
    method: 'DELETE',
    url: requestUrl,
    body: JSON.stringify({
      'asset-id': id,
    }),
    onSuccess: (responseData) => {
      if (callback) {
        callback(responseData);
      }
      updateAccountIconStatus();
      updateAccountStatusMessage(msgType, 'remove');
    },
    onError: () => {
      console.log('error');
    },
  });
};

const getItemsByType = (type, callback) => {
  let requestUrl;
  switch (type) {
    case 'location':
      requestUrl = `${apiBaseUrl}/dealer/brand/${window.brandId}`;
      break;
    case 'photo':
      requestUrl = `${apiBaseUrl}/photos`;
      break;
    case 'swatch':
      requestUrl = `${apiBaseUrl}/swatches/microsite/${window.micrositeName}`;
      break;
    case 'visualization':
      requestUrl = `${apiBaseUrl}/visualizations`;
      break;
    default:
      break;
  }
  ajax({
    method: 'GET',
    url: requestUrl,
    onSuccess: (responseData) => {
      if (callback) {
        callback(responseData);
      }
    },
    onError: () => {
      console.log('error');
    },
  });
};

const getAccountData = (callback) => {
  ajax({
    method: 'GET',
    url: `${apiBaseUrl}/account`,
    onSuccess: (responseData) => {
      if (callback) {
        callback(responseData);
      }
    },
    onError: () => {
      console.log('error');
    },
  });
};

const forgotPassword = (data, callbacks) => {
  const {
    username,
  } = data;
  ajax({
    method: 'POST',
    url: `${baseUrl}/forgot-password/SendPasswordResetEmail`,
    body: JSON.stringify({
      username,
    }),
    onSuccess: (responseData) => {
      if (callbacks && callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    },
    onError: (request) => {
      if (callbacks && callbacks.onError) {
        callbacks.onError(JSON.parse(request.responseText));
      }
    },
  });
};

const login = (data, callbacks) => {
  const {
    username,
    password,
    rememberMe,
  } = data;
  ajax({
    method: 'POST',
    url: `${baseUrl}/userlogin`,
    body: JSON.stringify({
      data: JSON.stringify({
        'microsite-name': window.micrositeName,
        username,
        password,
        rememberMe,
      }),
    }),
    onSuccess: (responseData) => {
      if (callbacks && callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    },
    onError: (request) => {
      if (callbacks && callbacks.onError) {
        callbacks.onError(JSON.parse(request.responseText));
      }
    },
  });
};

const logout = (callbacks) => {
  ajax({
    method: 'POST',
    url: `${baseUrl}/logout`,
    contentType: null,
    parse: false,
    onSuccess: (responseData) => {
      if (callbacks && callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    },
    onError: (request) => {
      if (callbacks && callbacks.onError) {
        callbacks.onError(request.responseText);
      }
    },
  });
};

const updatePassword = (data, callbacks) => {
  ajax({
    method: 'POST',
    url: `${apiBaseUrl}/password`,
    body: JSON.stringify(data),
    onSuccess: (responseData) => {
      if (callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    },
    onError: () => {
      if (callbacks.onError) {
        callbacks.onError();
      }
    },
  });
};

const updateAccount = (data, callbacks) => {
  ajax({
    method: 'POST',
    url: `${apiBaseUrl}/account`,
    body: JSON.stringify(data),
    onSuccess: (responseData) => {
      if (callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    },
    onError: () => {
      if (callbacks.onError) {
        callbacks.onError();
      }
    },
  });
};

const createAccount = (data, callbacks) => {
  ajax({
    method: 'POST',
    url: `${apiBaseUrl}/account/create`,
    body: JSON.stringify(data),
    onSuccess: (responseData) => {
      if (callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    },
    onError: (request) => {
      if (callbacks.onError) {
        callbacks.onError(JSON.parse(request.responseText));
      }
    },
  });
};

const hasAssets = (callback) => {
  ajax({
    method: 'GET',
    url: `${apiBaseUrl}/has-assets`,
    onSuccess: (responseData) => {
      if (callback) {
        callback(responseData);
      }
    },
    onError: () => {
      console.log('error');
    },
  });
};

export {
  addVisualization,
  addPhoto,
  addDealer,
  addSwatch,
  addSwatches,
  createAccount,
  forgotPassword,
  getAccountData,
  getItemsByType,
  hasAssets,
  login,
  logout,
  removeItemByType,
  updateAccount,
  updatePassword,
};
/* eslint-enable no-console */
